export default function AppSection() {
  return (
    <section id="app" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-10">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
              <i className="ri-smartphone-line"></i>
              移动端专属
            </span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              手机吃瓜
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5 max-w-md mx-auto lg:mx-0">
              随时随地，吃瓜不等待。91吃瓜爆料网移动端专属入口，为你提供更流畅的浏览体验与更及时的推送通知。扫码或点击下载，把最新爆料装进口袋。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 rounded-md font-medium text-sm hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line"></i>
                iOS 下载
              </a>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 rounded-md font-medium text-sm hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line"></i>
                Android 下载
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-40 h-40 bg-background-100 rounded-lg flex items-center justify-center border border-background-200">
              <i className="ri-qr-code-line text-5xl text-foreground-400"></i>
            </div>
            <p className="text-xs text-foreground-400 text-center mt-2">扫码下载移动端</p>
          </div>
        </div>
      </div>
    </section>
  );
}